<template>
  <div class="page_container">
    <div class="page_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/information' }">企业信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="page_card">
        <div class="ta-r mb-16">
          <el-button v-if="isEdit" size="small" @click="handleClickCancel">取消</el-button>
          <el-button v-if="isEdit" size="small" type="primary" :disabled="btnDisabled" @click="handleClickConfirm">保存</el-button>
          <el-button v-if="!isEdit" size="small" type="primary"  @click="handleClickEdit">编辑</el-button>
        </div>
        <div class="personal_box">
          <template  v-if="isEdit">
            <el-form :model="informationForm" :rules="informationFormRules" label-position="top" ref="personalForm"  size="small">
            <ul>
              <li>
                <div class="title">
                  基础信息
                </div>
                <div class="head_info">
                  <div class="head_img">
                    <img src="https://download.hecoos.com/enlightv/2024-33/dkd3HamkzAhsHzi3zARs.png" alt="">
                  </div>
                  <div class="head_text">
                    <p>澜景科技</p>
                    <p>费方健</p>
                  </div>
                </div>

                <div class="title">
                  其他信息
                </div>


                <el-row :gutter="20">
                  <el-col :span="5">
                    <el-form-item label="企业域名" prop="username">
                      <el-input type="text" v-model="informationForm.username" placeholder="请输入企业域名"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="企业编号" prop="username">
                      <el-input type="text" v-model="informationForm.username" placeholder="请输入企业编号"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="行业" prop="username">
                      <el-select v-model="informationForm.name" placeholder="请选择行业">
                        <el-option v-for="item in industryList" :value="item" :label="item"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="5">
                    <el-form-item label="数据驻留地" prop="username">
                      <el-input type="text" v-model="informationForm.username" placeholder="请输入数据驻留地"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="规模" prop="username">
                      <el-select v-model="informationForm.name" placeholder="请选择人数规模">
                        <el-option v-for="item in peopleNumberList" :value="item" :label="item"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>


                <div class="title">
                  企业联系人
                </div>
                <el-row :gutter="20">
                  <el-col :span="5">
                    <el-form-item label="姓名" prop="username">
                      <el-input type="text" v-model="informationForm.username" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="邮箱" prop="username">
                      <el-input type="text" v-model="informationForm.username" placeholder="请输入邮箱"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="电话" prop="username">
                      <el-input type="text" v-model="informationForm.username" placeholder="请输入电话"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </li>
            </ul>
          </el-form>
          </template>
          <template v-else>
            <el-form label-position="top"  size="small">
              <ul>
                <li>
                  <div class="title">
                    基础信息
                  </div>
                  <div class="head_info">
                    <div class="head_img">
                      <img src="https://download.hecoos.com/enlightv/2024-33/dkd3HamkzAhsHzi3zARs.png" alt="">
                    </div>
                    <div class="head_text">
                      <p>澜景科技</p>
                      <p>费方健</p>
                    </div>
                  </div>

                  <div class="title">
                    其他信息
                  </div>
                  <el-row :gutter="20">
                    <el-col :span="5">
                      <el-form-item label="企业域名">
                        <div>企业域名</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="企业编号">
                        <div>企业编号</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="行业">
                        <div>行业</div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="5">
                      <el-form-item label="数据驻留地">
                        <div>数据驻留地</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="规模">
                        <div>规模</div>
                      </el-form-item>
                    </el-col>
                  </el-row>


                  <div class="title">
                    企业联系人
                  </div>
                  <el-row :gutter="20">
                    <el-col :span="5">
                      <el-form-item label="姓名" prop="username">
                        <div>姓名</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="邮箱" prop="username">
                        <div>邮箱</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="电话" prop="username">
                        <div>电话</div>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-button size="small" type="primary"  @click="handleClickDissolution">解散企业</el-button>
                      <el-button size="small" type="primary"  @click="handleClickLogout">退出企业</el-button>
                    </el-col>
                  </el-row>


                </li>
              </ul>
            </el-form>
          </template>
        </div>


    </el-card>


    <logOut :outVisible.sync="outVisible" v-if="outVisible"  @success="logOutSuccess()"/>
    <dissolution :dissolutionVisible.sync="dissolutionVisible" v-if="dissolutionVisible"  @success="dissolutionSuccess()"/>

  </div>
</template>

<script>
import {} from '@/api/api'
import {mapState} from "vuex";
import {industryList} from '@/mixins'
import logOut from "./logout.vue";
import dissolution from "./dissolution.vue";

export default {
  name: 'information',
  components: {
    logOut,
    dissolution
  },
  data() {
    return {
      loading:false,
      outVisible:false,
      dissolutionVisible:false,
      informationForm: {},
      informationFormRules: {},
      informationDetail:{},
      btnDisabled:false,
      isEdit:false,

      peopleNumberList:[
        '0-19⼈',
        '20-99⼈',
        '100-499⼈',
        '500-999⼈',
        '1000⼈以上',
      ]
    }
  },

  mixins: [industryList],
  mounted() {
    // if(!this.webUserInfo || !this.webUserInfo.id){
    //   localStorage.removeItem('vuex')
    //   this.$router.replace('/')
    // }
  },
  computed: {
    ...mapState(['webUserInfo']),
  },
  methods: {
    // 编辑
    handleClickEdit(){
      this.isEdit = true
    },
    // 取消
    handleClickCancel(){
      this.isEdit = false
    },
    // 保存
    handleClickConfirm(){

    },

    // 退出企业
    handleClickLogout(){
      this.outVisible = true
    },
    // 解散企业
    handleClickDissolution(){
     this.dissolutionVisible = true
    },
    // 退出企业回调
    logOutSuccess(){

    },
    // 解散企业回调
    dissolutionSuccess(){

    },

  },
  watch: {},
}
</script>

<style scoped lang="scss">
.page_container .page_card {
  overflow-y: scroll;
  padding-bottom: 0px !important;
  background: transparent !important;
  box-shadow: none;

  ::v-deep .el-card__body {
    padding: 0px !important;
  }
}

.filed_list {
  color: #000;
  line-height: 24px;
  font-size: 16px;
  margin-bottom: 12px;
}


.personal_box {
  width: 100%;

  ul {
    width: 100%;

    li {
      width: 100%;
      margin-bottom: 24px;
      background: #fff;
      border-radius: 8px;
      padding: 24px 20px 6px;
      box-sizing: border-box;

      .title {
        width: 100%;
        line-height: 24px;
        color: rgba(51, 51, 51, 1);
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 16px;
      }

      .head_info {
        display: flex;
        margin-bottom: 24px;

        .head_img {
          width: 64px;

          img {
            display: block;
            width: 64px;
            height: 64px;
            object-fit: cover;
          }
        }

        .head_text {
          margin-left: 25px;

          p {
            line-height: 32px;
            font-size: 14px;
            color: rgba(51, 51, 51, 1);
          }
        }
      }

      ::v-deep .el-form-item__label {
        line-height: 22px;
      }

      .el-input {
        max-width: 262px;
      }

      .el-input-number {
        max-width: 262px;
        width: 262px;

        ::v-deep .el-input__inner {
          text-align: left;
        }
      }
    }
  }
}
</style>
